<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M5.87,12.5H8.12V23.25a.75.75,0,0,0,.75.75h5a.75.75,0,0,0,.75-.75V12.5h3.1a.75.75,0,0,0,.75-.67l.42-4A.75.75,0,0,0,18.13,7H14.62V5.84c0-.34.1-.35.26-.35h3a.75.75,0,0,0,.75-.75v-4A.75.75,0,0,0,17.87,0H13.54c-5,0-5.42,4.29-5.42,5.6V7H5.87a.75.75,0,0,0-.75.75v4A.75.75,0,0,0,5.87,12.5Zm.75-4H8.87a.75.75,0,0,0,.75-.75V5.6c0-1.53.51-4.1,3.92-4.1h3.58V4H14.88a1.71,1.71,0,0,0-1.76,1.85V7.75a.75.75,0,0,0,.75.75H17.3L17,11H13.87a.75.75,0,0,0-.75.75V22.5H9.62V11.75A.75.75,0,0,0,8.87,11H6.62Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'social-media-facebook',
    },
    name: {
      type: String,
      required: false,
      default: 'SocialMediaFacebook',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>